import React, { useState } from 'react'
import { Row, Typography, Card, Select, Col } from 'antd'
import { EmptyHeaderHero, SEO } from './components'
import 'isomorphic-fetch'
import { FORMS_DOCUMENTS_CLAIMS_LIST, FORMS_DOCUMENTS_POLICY_LIST } from '../constants'

import FormsDocsStyle from '../../styles/FormsAndDocuments.module.css'

const { Text } = Typography
const { Option } = Select

const FormsAndDocuments = () => {
  const [selectedState, setSelectedState] = useState('')

  const handleStateChange = key => {
    setSelectedState(key)
  }

  const subTitle = (
    <Text className={`${FormsDocsStyle["forms-and-documents-sub-title"]}`}>
      {' '}
      (For ID cards and other documents specific to your policy, please go to{' '}
      <a className={`${FormsDocsStyle["my-account"]}`} href="/my-account" rel="noreferrer">
        My Account
      </a>
      .)
    </Text>
  )

  return (
    <>
      <SEO
        description="NJ, PA, and MI policyholders can download forms and documents. Additional documents may be available in your account."
        title="Download Forms & Documents | CURE Auto Insurance"
        url="/forms-and-documents"
      />
      <EmptyHeaderHero leftAlign={true} minHeight={true} subTitle={subTitle} title="Forms/Documents" />
      <div className={`${FormsDocsStyle["forms-and-documents-screen"]}`}>
        <Row>
          <Card className={`${FormsDocsStyle["forms-and-documents-card"]}`}>
            <Row>
              <Select onChange={handleStateChange} placeholder="Select a state" value={selectedState || undefined}>
                <Option value="MI">Michigan</Option>
                <Option value="NJ">New Jersey</Option>
                <Option value="PA">Pennsylvania</Option>
              </Select>
            </Row>
            <Row className={`${FormsDocsStyle["forms-and-documents-policy-row"]}`}>
              {selectedState && <h5>POLICY</h5>}
              <Col span={24}>
                {selectedState &&
                  FORMS_DOCUMENTS_POLICY_LIST[selectedState].map(({ id, title, subText, content, link, showSubtext }) => (
                    <div key={id}>
                      <p>
                        <a className={`${FormsDocsStyle["forms-and-documents-hyperlinks"]}`} href={link} rel="noreferrer" target="_blank">
                          {title}{' '}
                          <span
                            className={`${FormsDocsStyle["mobile"]} ${FormsDocsStyle["forms-and-documents-sub-title"]}`}
                            style={{ color: 'rgba(0, 0, 0, 0.85)' }}
                          >
                            (PDF)
                          </span>
                          {showSubtext && (
                            <Text className={`${FormsDocsStyle["forms-and-documents-sub-title"]} ${FormsDocsStyle["desktop"]}`}>
                              <span className={`${FormsDocsStyle["desktop"]}`} style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                                (
                              </span>{' '}
                              {content}{' '}
                              <span className={`${FormsDocsStyle["desktop"]}`} style={{ color: '#000' }}>
                                )
                              </span>
                            </Text>
                          )}
                          {showSubtext && <Text className={`${FormsDocsStyle["forms-and-documents-sub-title"]} ${FormsDocsStyle["mobile"]}`}>{content}</Text>}
                        </a>
                      </p>
                    </div>
                  ))}
              </Col>
            </Row>
            <Row className={`${FormsDocsStyle["forms-and-documents-claims-row"]}`}>
              {selectedState && selectedState !== 'MI' && <h5>CLAIMS</h5>}
              <Col span={24}>
                {selectedState &&
                  FORMS_DOCUMENTS_CLAIMS_LIST[selectedState].map(
                    ({ id, title, subText, content, link, showSubtext }) => (
                      <div key={id}>
                        <p>
                          <a className={`${FormsDocsStyle["forms-and-documents-hyperlinks"]}`} 
                          href={link} rel="noreferrer" target="_blank">
                            {title}{' '}
                            <span
                              className={`${FormsDocsStyle["mobile"]} ${FormsDocsStyle["forms-and-documents-sub-title"]}`}
                              style={{ color: 'rgba(0, 0, 0, 0.85)' }}
                            >
                              (PDF)
                            </span>
                            {showSubtext && (
                              <Text className={`${FormsDocsStyle["forms-and-documents-sub-title"]} ${FormsDocsStyle["desktop"]}`}>
                                <span className={`${FormsDocsStyle["desktop"]}`} style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                                  (
                                </span>{' '}
                                {content}{' '}
                                <span className={`${FormsDocsStyle["desktop"]}`} style={{ color: '#000' }}>
                                  )
                                </span>
                              </Text>
                            )}
                            {showSubtext && <Text className={`${FormsDocsStyle["forms-and-documents-sub-title"]} ${FormsDocsStyle["mobile"]}`}>{content}</Text>}
                          </a>
                        </p>
                      </div>
                    )
                  )}
              </Col>
            </Row>
          </Card>
        </Row>
      </div>
    </>
  )
}

FormsAndDocuments.propTypes = {}

export default FormsAndDocuments
